import React, { useState } from 'react';
import { X, ChevronLeft } from 'lucide-react';

const BIBLE_BOOKS: { name: string; abbr: string; chapters: number[] }[] = [
  { name: 'Genesis', abbr: 'GEN', chapters: [31,25,24,26,32,22,24,22,29,32,32,20,18,24,21,16,27,33,38,18,34,24,20,67,34,35,46,22,35,43,55,32,20,31,29,43,36,30,23,23,57,38,34,34,28,34,31,22,33,26] },
  { name: 'Exodus', abbr: 'EXO', chapters: [22,25,22,31,23,30,25,32,35,29,10,51,22,31,27,36,16,27,25,26,36,31,33,18,40,37,21,43,46,38,18,35,23,35,35,38,29,31,43,38] },
  { name: 'Leviticus', abbr: 'LEV', chapters: [17,16,17,35,19,30,38,36,24,20,47,8,59,57,33,34,16,30,24,16,30,24,16,30,24,20,25,20,25,20,25,20,25,20,25,20,25,20,25,20] },
  { name: 'Numbers', abbr: 'NUM', chapters: [54,34,51,49,31,27,89,26,23,36,35,16,33,45,41,50,13,32,22,29,35,41,30,25,18,65,23,31,40,16,54,42,56,29,34,13] },
  { name: 'Deuteronomy', abbr: 'DEU', chapters: [46,37,29,49,33,25,26,20,29,22,32,32,18,29,23,22,20,22,21,20,23,30,25,22,19,19,26,68,29,20,30,52,29,12] },
  { name: 'Joshua', abbr: 'JOS', chapters: [18,24,17,24,15,27,26,35,27,43,23,24,33,15,63,10,18,28,51,9,45,34,16,33] },
  { name: 'Judges', abbr: 'JDG', chapters: [36,23,31,24,31,40,25,35,57,18,40,15,25,20,20,31,13,31,30,48,25] },
  { name: 'Ruth', abbr: 'RUT', chapters: [22,23,18,22] },
  { name: '1 Samuel', abbr: '1SA', chapters: [28,36,21,22,12,21,17,22,27,27,15,25,14,51,20,28,56,33,20,26,20,28,19,15,22] },
  { name: '2 Samuel', abbr: '2SA', chapters: [27,32,39,12,25,23,29,18,13,19,27,31,39,33,37,23,29,33,43,26,22,51,39,25] },
  { name: '1 Kings', abbr: '1KI', chapters: [53,46,28,34,18,38,51,66,28,29,43,33,34,31,34,34,24,46,21,43,29,53] },
  { name: '2 Kings', abbr: '2KI', chapters: [18,25,27,44,27,33,20,29,37,36,21,21,25,29,38,20,41,37,37,21,26,20,37,20,30] },
  { name: '1 Chronicles', abbr: '1CH', chapters: [54,55,24,43,26,81,40,40,44,14,47,40,14,17,29,43,27,17,19,8,30,19,32,31,31,32,34,21,30] },
  { name: '2 Chronicles', abbr: '2CH', chapters: [17,18,17,22,14,42,22,18,31,19,23,16,22,15,19,14,19,34,11,37,20,12,21,27,28,23,9,27,36,27,21,33,25,33,27,23] },
  { name: 'Ezra', abbr: 'EZR', chapters: [11,70,13,24,17,22,28,36,15,44] },
  { name: 'Nehemiah', abbr: 'NEH', chapters: [11,20,32,23,19,19,73,18,38,39,36,47,31] },
  { name: 'Esther', abbr: 'EST', chapters: [22,23,15,17,14,14,10,17,32,3] },
  { name: 'Job', abbr: 'JOB', chapters: [22,13,26,21,27,30,21,22,35,22,20,25,28,22,35,22,16,21,29,29,34,30,17,25,6,14,23,28,25,31,40,22,33,37,16,33,24,41,30,24,34,17] },
  { name: 'Psalms', abbr: 'PSA', chapters: [6,12,8,8,12,10,17,9,20,18,7,8,6,7,5,11,15,50,14,9,13,31,6,10,22,12,14,9,11,12,24,11,22,22,28,12,40,22,13,17,13,11,5,26,17,11,9,14,20,23,19,9,6,7,23,13,11,11,17,12,8,12,11,10,13,20,7,35,36,5,24,20,28,23,10,12,20,72,13,19,16,8,18,12,13,17,7,18,52,17,16,15,5,23,11,13,12,9,9,5,8,28,22,35,45,48,43,13,31,7,10,10,9,8,18,19,2,29,176,7,8,9,4,8,5,6,5,6,8,8,3,18,3,3,21,26,9,8,24,13,10,7,12,15,21,10,20,14,9,6] },
  { name: 'Proverbs', abbr: 'PRO', chapters: [33,22,35,27,23,35,27,36,18,32,31,28,25,35,33,33,28,24,29,30,31,29,35,34,28,28,27,28,62,44,39,49,43,54,70,36,45,47,19] },
  { name: 'Ecclesiastes', abbr: 'ECC', chapters: [18,26,22,16,20,12,29,17,18,20,10,14] },
  { name: 'Song of Solomon', abbr: 'SNG', chapters: [17,17,11,16,16,13,13,14] },
  { name: 'Isaiah', abbr: 'ISA', chapters: [31,22,26,6,30,13,25,22,21,34,16,6,22,32,9,14,14,7,25,6,17,25,18,23,12,21,13,29,24,33,9,20,24,17,10,22,38,22,8,31,29,25,28,28,25,13,15,22,26,11,23,15,12,17,13,12,21,14,21,22,11,12,19,12,25,24] },
  { name: 'Jeremiah', abbr: 'JER', chapters: [19,37,25,31,31,30,34,22,26,25,23,17,27,22,21,21,27,23,15,18,14,30,40,10,38,24,22,17,32,24,40,44,26,22,19,32,21,28,18,16,18,22,13,30,5,28,7,47,39,46,64,34] },
  { name: 'Lamentations', abbr: 'LAM', chapters: [22,22,66,22,22] },
  { name: 'Ezekiel', abbr: 'EZK', chapters: [28,10,27,17,17,14,27,18,11,22,25,28,23,23,8,63,24,32,14,49,32,31,49,27,17,21,36,26,21,26,18,32,33,31,15,38,28,23,29,49,26,20,27,31,25,24,23,35] },
  { name: 'Daniel', abbr: 'DAN', chapters: [21,49,30,37,31,28,28,27,27,21,45,13] },
  { name: 'Hosea', abbr: 'HOS', chapters: [11,23,5,19,15,11,16,14,17,15,12,14,16,9] },
  { name: 'Joel', abbr: 'JOL', chapters: [20,32,21] },
  { name: 'Amos', abbr: 'AMO', chapters: [15,16,15,13,27,14,17,14,15] },
  { name: 'Obadiah', abbr: 'OBA', chapters: [21] },
  { name: 'Jonah', abbr: 'JON', chapters: [17,10,10,11] },
  { name: 'Micah', abbr: 'MIC', chapters: [16,13,12,13,15,16,20] },
  { name: 'Nahum', abbr: 'NAM', chapters: [15,13,19] },
  { name: 'Habakkuk', abbr: 'HAB', chapters: [17,20,19] },
  { name: 'Zephaniah', abbr: 'ZEP', chapters: [18,15,20] },
  { name: 'Haggai', abbr: 'HAG', chapters: [15,23] },
  { name: 'Zechariah', abbr: 'ZEC', chapters: [21,13,10,14,11,15,14,23,17,12,17,14,9,21] },
  { name: 'Malachi', abbr: 'MAL', chapters: [14,17,18,6] },
  { name: 'Matthew', abbr: 'MAT', chapters: [25,23,17,25,48,34,29,34,38,42,30,50,58,36,39,28,27,35,30,34,46,46,39,51,46,75,66,20] },
  { name: 'Mark', abbr: 'MRK', chapters: [45,28,35,41,43,56,37,38,50,52,33,44,37,72,47,20] },
  { name: 'Luke', abbr: 'LUK', chapters: [80,52,38,44,39,49,50,56,62,42,54,59,35,35,32,31,37,43,48,47,38,71,56,53] },
  { name: 'John', abbr: 'JHN', chapters: [51,25,36,54,47,71,53,59,41,42,57,50,38,31,27,33,26,40,42,31,25] },
  { name: 'Acts', abbr: 'ACT', chapters: [26,47,26,37,20,32,36,60,40,33,35,27,26,20,32,36,33,31,15,38,32,41,22,36,27,27,32,44,31] },
  { name: 'Romans', abbr: 'ROM', chapters: [32,29,31,25,21,23,25,39,33,21,36,21,14,26,33,24] },
  { name: '1 Corinthians', abbr: '1CO', chapters: [31,16,23,21,13,20,40,13,27,33,34,31,13,40,58,24] },
  { name: '2 Corinthians', abbr: '2CO', chapters: [24,17,18,18,21,18,16,24,15,18,33,21,14] },
  { name: 'Galatians', abbr: 'GAL', chapters: [24,21,29,31,26,18] },
  { name: 'Ephesians', abbr: 'EPH', chapters: [23,22,21,28,22,31] },
  { name: 'Philippians', abbr: 'PHP', chapters: [30,30,21,23] },
  { name: 'Colossians', abbr: 'COL', chapters: [29,23,25,18] },
  { name: '1 Thessalonians', abbr: '1TH', chapters: [10,20,13,18,28] },
  { name: '2 Thessalonians', abbr: '2TH', chapters: [12,17,18] },
  { name: '1 Timothy', abbr: '1TI', chapters: [20,15,16,16,25,21] },
  { name: '2 Timothy', abbr: '2TI', chapters: [18,26,17,22] },
  { name: 'Titus', abbr: 'TIT', chapters: [16,15,15] },
  { name: 'Philemon', abbr: 'PHM', chapters: [25] },
  { name: 'Hebrews', abbr: 'HEB', chapters: [14,18,19,16,14,20,28,13,28,39,40,29,25] },
  { name: 'James', abbr: 'JAS', chapters: [27,26,18,17,20] },
  { name: '1 Peter', abbr: '1PE', chapters: [25,25,22,19,14] },
  { name: '2 Peter', abbr: '2PE', chapters: [21,22,18] },
  { name: '1 John', abbr: '1JN', chapters: [10,29,24,21,21] },
  { name: '2 John', abbr: '2JN', chapters: [13] },
  { name: '3 John', abbr: '3JN', chapters: [14] },
  { name: 'Jude', abbr: 'JUD', chapters: [25] },
  { name: 'Revelation', abbr: 'REV', chapters: [20,29,22,11,14,17,17,13,21,11,19,17,18,20,8,21,18,24,21,15,27,21] },
];

type Step = 'book' | 'chapter' | 'verse';

interface Props {
  onSelect: (reference: string) => void;
  onClose: () => void;
}

function NumGrid({ count, selected, rangeStart, onPick }: {
  count: number;
  selected?: number;
  rangeStart?: number;
  onPick: (n: number) => void;
}) {
  return (
    <div className={`grid grid-cols-6 gap-1 ${count > 60 ? 'overflow-y-auto max-h-64' : ''}`}>
      {Array.from({ length: count }, (_, i) => i + 1).map(n => {
        const isSelected = n === selected;
        const inRange = rangeStart !== undefined && n > rangeStart && n === selected;
        return (
          <button
            key={n}
            onClick={() => onPick(n)}
            className={`py-2 rounded-lg text-sm font-semibold transition-colors
              ${isSelected || inRange
                ? 'bg-blue-600 text-white'
                : 'bg-gray-100 text-gray-700 hover:bg-blue-100 hover:text-blue-700'
              }`}
          >
            {n}
          </button>
        );
      })}
    </div>
  );
}

export const BiblePicker: React.FC<Props> = ({ onSelect, onClose }) => {
  const [step, setStep] = useState<Step>('book');
  const [book, setBook] = useState(BIBLE_BOOKS[0].name);
  const [chapter, setChapter] = useState<number | null>(null);
  const [startVerse, setStartVerse] = useState<number | null>(null);
  const [endVerse, setEndVerse] = useState<number | null>(null);

  const bookData = BIBLE_BOOKS.find(b => b.name === book)!;
  const numChapters = bookData.chapters.length;
  const numVerses = chapter ? bookData.chapters[chapter - 1] : 0;

  const preview = chapter && startVerse
    ? endVerse && endVerse > startVerse
      ? `${book} ${chapter}:${startVerse}-${endVerse}`
      : `${book} ${chapter}:${startVerse}`
    : chapter
      ? `${book} ${chapter}`
      : book;

  const handleBookChange = (b: string) => {
    setBook(b);
    setChapter(null);
    setStartVerse(null);
    setEndVerse(null);
  };

  const handleChapterPick = (c: number) => {
    setChapter(c);
    setStartVerse(null);
    setEndVerse(null);
    setStep('verse');
  };

  const handleVersePick = (v: number) => {
    if (startVerse === null) {
      setStartVerse(v);
      setEndVerse(null);
    } else if (v === startVerse) {
      setStartVerse(null);
      setEndVerse(null);
    } else if (v > startVerse) {
      setEndVerse(prev => prev === v ? null : v);
    } else {
      setStartVerse(v);
      setEndVerse(null);
    }
  };

  const handleConfirm = () => {
    if (!chapter || !startVerse) return;
    const ref = endVerse && endVerse > startVerse
      ? `${book} ${chapter}:${startVerse}-${endVerse}`
      : `${book} ${chapter}:${startVerse}`;
    onSelect(ref);
    onClose();
  };

  const stepTitle = step === 'book' ? 'Select Book' : step === 'chapter' ? `${book} — Chapter` : `${book} ${chapter} — Verse`;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50" onClick={onClose}>
      <div
        className="bg-white rounded-xl shadow-2xl w-full max-w-sm flex flex-col overflow-hidden"
        style={{ maxHeight: '90vh' }}
        onClick={e => e.stopPropagation()}
      >
        {/* Header */}
        <div className="bg-blue-600 px-4 py-3 flex items-center justify-between">
          <div className="flex items-center gap-2">
            {step !== 'book' && (
              <button
                onClick={() => setStep(step === 'verse' ? 'chapter' : 'book')}
                className="text-white hover:text-blue-200 mr-1"
              >
                <ChevronLeft size={20} />
              </button>
            )}
            <span className="text-white font-bold text-base uppercase tracking-wide">{stepTitle}</span>
          </div>
          <button onClick={onClose} className="text-white hover:text-blue-200">
            <X size={20} />
          </button>
        </div>

        {/* Body */}
        <div className="p-4 flex-1 overflow-y-auto bg-white">
          {step === 'book' && (
            <div className="grid grid-cols-6 gap-1">
              {BIBLE_BOOKS.map((b) => {
                return (
                  <button
                    key={b.name}
                    onClick={() => { handleBookChange(b.name); setStep('chapter'); }}
                    className={`py-2 rounded text-xs font-bold tracking-wide transition-colors
                      ${book === b.name
                        ? 'bg-blue-600 text-white'
                        : 'bg-gray-100 text-gray-700 hover:bg-blue-100 hover:text-blue-700'
                      }`}
                  >
                    {b.abbr}
                  </button>
                );
              })}
            </div>
          )}

          {step === 'chapter' && (
            <NumGrid count={numChapters} selected={chapter ?? undefined} onPick={handleChapterPick} />
          )}

          {step === 'verse' && (
            <div className="space-y-3">
              <NumGrid
                count={numVerses}
                selected={startVerse ?? undefined}
                onPick={handleVersePick}
              />
              {startVerse && (
                <div className="text-xs text-gray-500 text-center">
                  {endVerse && endVerse > startVerse
                    ? `Range: verse ${startVerse}–${endVerse} · tap end verse again to deselect`
                    : `Tap another verse to select a range`}
                </div>
              )}
            </div>
          )}
        </div>

        {/* Footer */}
        <div className="px-4 py-3 border-t border-gray-100 space-y-2 bg-white">
          <div className="text-sm text-blue-700 font-semibold text-center bg-blue-50 rounded-lg py-2 px-3">
            {preview}
          </div>
          <div className="flex gap-2">
            <button
              onClick={onClose}
              className="flex-1 py-2 border border-gray-300 text-gray-600 rounded-lg text-sm hover:bg-gray-50 transition-colors"
            >
              Cancel
            </button>
            <button
              onClick={handleConfirm}
              disabled={!chapter || !startVerse}
              className="flex-1 py-2 bg-blue-600 text-white rounded-lg text-sm font-medium hover:bg-blue-700 transition-colors disabled:opacity-40 disabled:cursor-not-allowed"
            >
              Use This Verse
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
